import { Channel, usePageState } from "@at/sauron-platform-core";

export const useChannel = (): Channel => {
  return usePageState().state.channel;
};
